import pluralize from 'pluralize'
import qs from 'qs'
import moment from 'admin/lib/moment'
import {camelCase as camel, snakeCase as snake, capitalize as cap} from 'lodash'

export const camelCase = camel
export const snakeCase = snake
export const capitalize = cap

export const titlecase = text => capitalize(snakeCase(text).replace(/_/g, ' '))

// pluralize('test', 5) //=> "tests"
// pluralize('test', 1, true) //=> "1 test"
export const pluralise = (word, count, prefix) => {
  if (!!word) {
    return pluralize(word, count, prefix)
  } else if (prefix) {
    return count
  } else {
    return word
  }
}

export const toSentence = arr => {
  if (arr.length > 1) {
    return arr.slice(0, -1).join(', ') + ' and ' + arr.slice(-1)
  } else {
    return arr[0]
  }
}

export const toPagination = (count, totalCount, type) => {
  if (count === totalCount) return `all ${type ? pluralise(type, totalCount, true) : totalCount}`
  return `${count} of ${type ? pluralise(type, totalCount, true) : totalCount}`
}

export const formatNumber = (number, opts = {}) => {
  if (number !== 0 && !number) {
    return 0
  }
  if (opts.accounting) {
    if (number > 0) {
      // credits show in brackets (the opposite of accounting formats - usually negative numbers are in brackets)
      const num = new Intl.NumberFormat('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(number)
      return `(${num})`
    } else {
      return new Intl.NumberFormat('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(
        Math.abs(number)
      )
    }
  } else if (opts.currency) {
    return new Intl.NumberFormat('en-IN', {style: 'currency', currency: 'NZD', currencyDisplay: 'symbol'}).format(
      number
    )
  } else {
    return new Intl.NumberFormat('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(number)
  }
}

export const asVariable = text => text.toLowerCase().replace(/_(.)/g, v => v.charAt(1).toUpperCase())

export const frequencyInWords = (count, frequency) => {
  let word = {monthly: 'month', weekly: 'week'}[frequency]
  return pluralise(word, count, true)
}

const dayUnits = [
  ['year', 365],
  ['month', 30],
  ['week', 7],
  ['day', 1]
]
export const daysToFrequency = days => {
  if (days == null || days === 0) return null

  for (const [name, dayUnit] of dayUnits) {
    if (days >= dayUnit) {
      let value = days / dayUnit
      value = Math.round(value * 2) / 2 // round to nearest 0.5
      value = value % 1 === 0 ? value.toString() : Math.floor(value) // format nicely (no ".0")

      if (name === 'day' && Number(value) === 1) return 'Daily'
      if (name === 'week' && Number(value) === 1) return 'Weekly'
      if (name === 'week' && Number(value) === 2) return 'Fortnightly'
      if (name === 'month' && Number(value) === 1) return 'Monthly'
      if (name === 'year' && Number(value) === 1) return 'Yearly'
      return `Every ${pluralise(name, Number(value), true)}`
    }
  }
}

export const formatDate = date => {
  if (!date || date === '') return null
  if (!moment.isMoment(date)) date = moment(date)
  return date.format('D MMM YYYY')
}

export const formatTime = (timeString, multiline = false) => {
  if (!timeString || !timeString.length) return null
  return moment(timeString).format(`D MMM YYYY${multiline ? '[\n]' : ' '}h:mm a`)
}

export const toParams = (data, snakecase = true) =>
  qs.stringify(data, {
    arrayFormat: 'brackets',
    encoder: (str, defaultEncoder, _charset, type) => {
      if (type === 'key' && snakecase) str = str.replace(/(\w+)/g, snakeCase)
      return defaultEncoder(str)
    }
  })
